import { generateFormFieldNames } from "../../../utils";

export enum LOGIN_FORM_STEPS {
    PHONE_NUMBER = "phoneNumber",
    OTP = "otp",
    COMPANY_NAME = "companyName",
    SERVICE_TYPE_SELECTION = "serviceTypeSelection",
    SUCCESS_SCREEN = "successScreen",
    MANDATE_LORRY_POSTING_SUCCESS_SCREEN = "mandateLorryPostingSuccessScreen"
}

interface LoginFormMetaFields {
    showCurrentLocationField: boolean;
}

export interface LoginFormFieldsTypes extends LoginFormMetaFields {
    phoneNumber: string;
    /** Digits as typed. Kept as a string so a leading zero survives to the API boundary. */
    otp: string;
    companyName: string;
    serviceType: string;
    referralCode: string;
    currentPlaceID: string;
    whatsappUpdatesEnabled: boolean;
}

export const initialLoginFormValues: LoginFormFieldsTypes = {
    phoneNumber: "",
    otp: "",
    companyName: "",
    serviceType: "",
    referralCode: "",
    whatsappUpdatesEnabled: true,
    currentPlaceID: "",
    showCurrentLocationField: true
};

export const loginFormFieldNames = generateFormFieldNames(initialLoginFormValues);

// export const LoginFormModel = {
//     phoneNum: phoneNumModel,
//     otp: otpModel,
//     companyName: companyNameModel,
//     serviceType: serviceTypeModel,
//     success: {
//         id: "success",
//         fields: {}
//     }
// };

// const LoginFormValidationModel = {
//     [LOGIN_FORM_STEPS.PHONE_NUMBER]: {
//         id: LOGIN_FORM_STEPS.PHONE_NUMBER,

//     }
// };
